(function () {
	const SECTION_TYPE = 'brand-carousel';

	function ready(fn) {
		if (document.readyState !== 'loading') fn();
		else document.addEventListener('DOMContentLoaded', fn);
	}

	function waitForSlick(maxTries = 40, interval = 100) {
		return new Promise((resolve, reject) => {
			let tries = 0;
			const tick = () => {
				const ok = window.jQuery && typeof window.jQuery.fn?.slick === 'function';
				if (ok) {
					resolve(window.jQuery);
					return;
				}
				tries++;
				if (tries >= maxTries) {
					reject(new Error('Slick not available'));
					return;
				}
				setTimeout(tick, interval);
			};
			tick();
		});
	}

	function parseBool(val) {
		if (typeof val === 'boolean') return val;
		if (typeof val === 'string') return val === 'true' || val === '1';
		return !!val;
	}

	function createSlide(item, itemSize) {
		const name = item.name || item.title || item.label || '';
		let img = item.image || item.logo || item.image_url || item.src || '';

		// Fallback for ULTER
		if (name && name.toUpperCase() === 'ULTER') {
			img = 'https://cdn.shopify.com/s/files/1/2488/5538/files/download_5.png?v=1779965250';
		}

		const url = item.url || item.link || item.href || '#';

		const slide = document.createElement('div');
		slide.className = 'brand-carousel__item';
		const logo = document.createElement('div');
		logo.className = 'brand-carousel__logo';
		logo.style.setProperty('--bc-item-size', itemSize + 'px');

		const a = document.createElement('a');
		a.className = 'brand-carousel__link';
		a.href = url || '#';
		if (/^https?:\/\//i.test(url)) a.target = '_blank';
		a.rel = 'noopener';

		const imgEl = document.createElement('img');
		imgEl.className = 'brand-carousel__image';
		imgEl.loading = 'lazy';
		imgEl.decoding = 'async';
		imgEl.alt = name || 'brand';
		imgEl.src = img;

		a.appendChild(imgEl);

		const nameEl = document.createElement('span');
		nameEl.className = 'brand-carousel__name';
		nameEl.innerHTML = name.replace('WHITELINE/NOLATHANE', 'WHITELINE<br>NOLATHANE');
		a.appendChild(nameEl);

		logo.appendChild(a);
		slide.appendChild(logo);

		return slide;
	}

	function normalizeData(data) {
		if (Array.isArray(data)) return data;
		if (data && Array.isArray(data.brands)) return data.brands;
		if (data && Array.isArray(data.items)) return data.items;
		if (data && typeof data === 'object') {
			// try to extract first array value
			const firstArray = Object.values(data).find(Array.isArray);
			if (firstArray) return firstArray;
		}
		return [];
	}

	function initSection($, section) {
		const container = section.querySelector('.js-brand-carousel');
		if (!container) return;

		const endpoint = section.getAttribute('data-endpoint') || `${window.apiConfig?.ozPartsApiBase || 'https://app.menvaraosat.fi/api/oz-parts'}/all-products-brands`;
		const slidesDesktop = parseInt(section.getAttribute('data-slides-desktop') || '7', 10);
		const slidesTablet = parseInt(section.getAttribute('data-slides-tablet') || '5', 10);
		const slidesMobile = parseInt(section.getAttribute('data-slides-mobile') || '3', 10);
		const autoplay = parseBool(section.getAttribute('data-autoplay'));
		const autoplaySpeed = parseInt(section.getAttribute('data-autoplay-speed') || '3000', 10);
		const infinite = parseBool(section.getAttribute('data-infinite'));
		const arrows = parseBool(section.getAttribute('data-arrows'));
		const dots = parseBool(section.getAttribute('data-dots'));
		// Не округляем размер логотипа: поддерживаем дробные значения, если они придут из настроек
		const itemSizeAttr = section.getAttribute('data-item-size');
		const itemSizeParsed = itemSizeAttr != null ? parseFloat(itemSizeAttr) : NaN;
		const itemSize = Number.isFinite(itemSizeParsed) ? itemSizeParsed : 146;

		const destroySlick = () => {
			try {
				if ($(container).hasClass('slick-initialized')) $(container).slick('unslick');
			} catch (e) { /* noop */
			}
		};

		const renderItems = (items) => {
			container.innerHTML = '';
			items.forEach(it => container.appendChild(createSlide(it, itemSize)));
		};

		const initSlick = () => {
			if (!window.jQuery) return;
			const $el = $(container);
			if ($el.hasClass('slick-initialized')) $el.slick('unslick');
			// Custom arrow SVG (next). Prev will reuse the same SVG and be rotated via CSS.
			const arrowSvg = `\n<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0.75 0.75L6 6L0.75 11.25" stroke="#20232D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>`;
			const isNarrow = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(max-width: 992px)').matches : false;

			const handleClick = (e) => {
				const link = e.target.closest('a');
				if (!link) return;
				const url = new URL(link.href, window.location.origin);
				const brandName = url.searchParams.get('brand_name');
				if (brandName) {
					localStorage.setItem('oz_parts_brand_name', brandName);
				}
			};

			$el[0].removeEventListener('click', handleClick);
			$el[0].addEventListener('click', handleClick);

			$el.slick({
				slidesToShow: slidesDesktop,
				slidesToScroll: 1,
				infinite: infinite,
				arrows: arrows,
				prevArrow: `<button type="button" class="slick-prev" aria-label="Previous">${arrowSvg}</button>`,
				nextArrow: `<button type="button" class="slick-next" aria-label="Next">${arrowSvg}</button>`,
				dots: !!(dots || isNarrow),
				autoplay: autoplay,
				autoplaySpeed: autoplaySpeed,
				speed: 450,
				cssEase: 'ease',
				adaptiveHeight: false,
				responsive: [
					{ breakpoint: 1200, settings: { slidesToShow: Math.max(2, slidesTablet) } },
					// <= 992px: скрываем стрелки, показываем точки
					{ breakpoint: 992, settings: { slidesToShow: Math.max(2, slidesTablet), arrows: false, dots: true } },
					{ breakpoint: 768, settings: { slidesToShow: 4, arrows: false, dots: true } },
					{ breakpoint: 650, settings: { slidesToShow: 3, arrows: false, dots: true } },
					{ breakpoint: 500, settings: { slidesToShow: 2, arrows: false, dots: true } }
				]
			});
		};

		const showSkeleton = () => {
			const loading = section.querySelector('.brand-carousel__loading');
			if (loading) {
				container.innerHTML = loading.outerHTML;
			}
		};

		const showError = (msg) => {
			container.innerHTML = `<div class="m:text-center m:text-sm" style="padding:12px 0; opacity:.75;">${msg}</div>`;
		};

		const load = async () => {
			if (!endpoint) return;

			showSkeleton();

			try {
				const res = await fetch(endpoint, {
					method: 'GET'
				});
				if (!res.ok) throw new Error('HTTP ' + res.status);
				const data = await res.json();
				let list = normalizeData(data);
				if (!list.length) {
					showError('No data found');
					return;
				}

				// Map API data to component format
				list = list.map(item => ({
					...item,
					url: item.name ? `/pages/oz-parts?brand_name=${encodeURIComponent(item.name)}` : (item.url || item.link || '#'),
					name: item.name || item.brandName || item.title || '',
					image: item.imgLogo || item.image || item.logo || item.imageUrl || ''
				})).filter(item => item.image);

				renderItems(list);
				initSlick();
			} catch (e) {
				console.error('[brand-carousel] load error:', e);
				showError('Falied to load data');
			}
		};

		load();

		return { destroy: destroySlick };
	}

	function bootstrap() {
		waitForSlick().then(($) => {
			document.querySelectorAll(`[data-section-type="${SECTION_TYPE}"]`).forEach(section => initSection($, section));
		}).catch(() => {
			document.querySelectorAll(`[data-section-type="${SECTION_TYPE}"]`).forEach(section => initSection(window.jQuery || null, section));
		});
	}

	// Theme editor support
	document.addEventListener('shopify:section:load', function (e) {
		const section = e.target?.querySelector?.(`[data-section-type="${SECTION_TYPE}"]`) || null;
		if (!section) return;
		bootstrap();
	});
	document.addEventListener('shopify:section:unload', function (e) {
		const section = e.target?.querySelector?.(`[data-section-type="${SECTION_TYPE}"]`) || null;
		if (!section) return;
		try {
			if (window.jQuery) {
				const $el = window.jQuery(section).find('.js-brand-carousel');
				if ($el.hasClass('slick-initialized')) $el.slick('unslick');
			}
		} catch (err) {/* noop */
		}
	});

	ready(bootstrap);
})();
